<template>
    <div class="employeeLIstVue">
        <div class="o-main-content-area">
            <div class="row c-responsive-fixwidth">
                <div class="col-md-3">
                    <h1 class="h1">Employees</h1>
                </div>
                <div class="col-md-9 text-right">
                    <ul class="o-filter-area">
                        <li class="o-search-field">
                            <div class="input-group stylish-input-group">
                                <input type="text" class="form-control" placeholder="Search" v-model="search_query" v-on:keyup="updateValue">
                                <span class="input-group-addon">
                                    <button type="submit">
                                    <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                </button>
                                </span>
                            </div>
                        </li>
                        <li>
                            <a href="javascript: void(0)" 
                                @click="goToMerge()" 
                                class="c-common-btn c-common-btn--inverse-icon-green"
                            >
                                <i class="fa fa-plus" aria-hidden="true"></i> 
                                Merge Employee
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable">
                <div class="c-common-space o-individual-calls">
                    <div class="col-md-12 o-no-padding">
                        <form class="form-inline">
                            <div class="form-group ">
                                <label for="exampleInputEmail3" class="common-label-text">Sort By</label>
                                <div class="o-cutsomSelect o-display-inline">
                                    <select v-model="selectedShortType" @change="getAllEmployee()" class="form-control fix-width-input">
                                        <option value="fname_asc">FirstLast (Employee name)</option>
                                        <option value="fname_desc">LastFirst (Employee name)</option>
                                        <option value="seniority">Seniority </option>
                                        <option value="email">Email ID</option>      
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="o-skills-listing">
                    <div class="row">
                        <div class="col col-sm-12">
                        <div class="o-scheduleTable--daily">
                                <div  
                                    infinite-scroll-disabled="busy" 
                                    infinite-scroll-distance="10" 
                                    v-loading="loading"
                                    v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                                    ref="scrollContainer"
                                    style="min-height: 1px;overflow:auto;"
                                >
                                    <div 
                                        v-for="(employee,empIndex) in employees" :key="empIndex" 
                                        class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 employees-list-table-align employees-list-table"
                                    >
                                        <div class="calls-table-row">
                                            <div class="calls-table-cell">
                                                <div class="o-right-side-padding5">
                                                    <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">
                                                        <div class="o-accordion-subtext user-icon o-list-user-img">
                                                            <div class="o-post-logged o-post-logged--table-user">
                                                                <div class="o-user-profile-img o-header-profile-pic">
                                                                    <div v-if="employee.employable">
                                                                        <img 
                                                                            v-if="employee.employable.image && employee.employable.image != '' &&employee.employable.image != 'NULL'" 
                                                                            :src="(employee.employable.image)"  id='img-upload'/>
                                                                        <img 
                                                                            v-if="!employee.employable.image && employee.employable.image == '' ||employee.employable.image == 'NULL'" 
                                                                            src="static/assets/images/user1.png" id='img-upload' />
                                                                    </div> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Name</span>
                                                            
                                                            <div>
                                                                {{employee.employable ? ((selectedShortType=='fname_asc')?employee.employable.first_name+" "+employee.employable.last_name:
                                                                (selectedShortType=='fname_desc'?employee.employable.last_name+", "
                                                                +employee.employable.first_name:employee.employable.first_name+" "+employee.employable.last_name)):'--'}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right table-td-border-left o-right-side-padding5 ">
                                                    <div class="calls-table-cell-inner-table">
                                                        <div class="o-accordion-subtext o-rowtable-text o-no-padding">
                                                            <span>Client:</span>
                                                            <div>
                                                                {{ employee.client_employee && employee.client_employee.clients && employee.client_employee.clients.subdomain ? 
                                                                employee.client_employee.clients.subdomain +' ('+employee.client_employee.clients.contact_person+')' : ' -- '}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="calls-table-cell">
                                                    <div class="o-right-side-padding5 ">
                                                    <div class="calls-table-cell-inner-table">
                                                        
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right o-right-side-padding5">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Email ID:</span>
                                                        <div>{{employee.employable ? employee.employable.email:'--'}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right o-right-side-padding5">
                                                    <div  class="o-accordion-subtext o-rowtable-text">
                                                        <span>Send:</span>
                                                        <div class="notify-icon">
                                                            <a href="javascript: void(0)" class="send-reset-email" @click="sendEmail(employee)">
                                                                Email Reset Link
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right o-right-side-padding5">
                                                    <div  class="o-accordion-subtext o-rowtable-text">
                                                        <span>Phone:</span>
                                                        <div v-if="employee.employable">
                                                            <div v-for="(phone,phoneIndex) in employee.employable.phones" :key="phoneIndex" 
                                                            v-if="phone.label=='Home phone' || phone.label=='home'">
                                                                <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                                                {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                                            </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right o-right-side-padding5">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Cell:</span>
                                                        <div v-if="employee.employable">
                                                            <div v-for="(phone,phoneIndex) in employee.employable.phones" :key="phoneIndex" 
                                                            v-if="phone.label=='Cell phone' || phone.label=='mobile' || phone.label=='cell'">
                                                                <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                                                {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                                            </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right o-right-side-padding5">
                                                    <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                        <span class="">Send Event</span>
                                                        <div class="notify-icon">
                                                            <a 
                                                                href="javascript: void(0)" class="nylas-event" 
                                                                :class="{'active':getNylasSubscriptionStatus(employee),'inactive':!getNylasSubscriptionStatus(employee)}"
                                                                @click="sendNylasEvent(employee)"
                                                            >
                                                                <img class="nylas-logo" src="static/assets/images/nylas-logo.svg" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right o-right-side-padding5">
                                                    <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                        <span class="">Notify</span>
                                                        <div class="notify-icon">
                                                            <a href="javascript: void(0)" @click="addBatchNotify(employee)"><i class="fa fa-mobile" aria-hidden="true"></i></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="calls-table-cell">
                                                <div class="">
                                                    <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                        <span class="">View</span>
                                                        <br />
                                                        <a class="notify-icon" :href="goToLogin(employee.id)" target="_blank">
                                                            <i class="fa fa-eye" aria-hidden="true"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="employees.length==0 && afterApi">
                        <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                            <div class="col-md-12 no-job-dispaly">
                                <i class="fa fa-frown-o" aria-hidden="true"></i>
                                <br />
                                No Data Stored
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal name="batch-notify"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div class="modal-add-newJob" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center o-small-modal-head">
                            <button 
                                @click="closeBatchNotify()" 
                                type="button" class="close custom-modal--close" 
                                data-dismiss="modal" aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h4 class="modal-title">Notify</h4>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-nopad-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <ul class="o-modal-tab">
                                        <li v-if="getNotificationType=='email'">
                                            <a href="javascript: void(0)" @click="notifyEmailTab()" :class="(notifyTab == 'email')?'o-tab-active':''">
                                                Email
                                            </a>
                                        </li>
                                        <li 
                                            v-if="getNotificationType=='sms'">
                                            <a href="javascript: void(0)" @click="notifySmsTab()" :class="(notifyTab == 'sms')?'o-tab-active':''">
                                                SMS
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-sm-12" v-if="notifyTab == 'email'">
                                    <div class="form-group o-attachment-sec">
                                        <vue-editor 
                                            id="editor1" 
                                            class="c-common-box-shadow c-radius3" 
                                            :class="{ 'error-border': hasError }"
                                            v-model="emailContent" 
                                            style="height: 220px;"
                                            @text-change="validateContent('email', emailContent)"
                                        ></vue-editor>
                                        <span 
                                            v-if="error.email && error.email.hasError" 
                                            class="err-msg"
                                        >
                                            {{ error.email.message }}
                                        </span>

                                        <div class="common-label-input--modalwidth o-upload-file attachment-btn-wrapper">
                                            <button class="btn o-attachment-icon"><i class="fa fa-paperclip" aria-hidden="true"></i></button>
                                            <input type="file" name="myfile" @change="attachmentAdded($event)">
                                            <span>{{(attachment)?attachment.name:'No file chosen'}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12" v-if="notifyTab == 'sms'">
                                    <div class="o-sms-counter o-sms-counter-normal">{{smsContent.length}}/160</div>
                                    <textarea 
                                        :maxlength="160"
                                        class="form-control o-no-radius notifySms-field" 
                                        :class="{ 'error-border': error.sms && error.sms.hasError }"
                                        v-model="smsContent"
                                        rows="10"
                                        placeholder="Type your SMS"
                                        @input="validateContent('sms', smsContent)"
                                    ></textarea>
                                    <span 
                                        v-if="error.sms && error.sms.hasError" 
                                        class="err-msg"
                                    >
                                        {{ error.sms.message }}
                                    </span>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a 
                                        href="javascript: void(0)" 
                                        @click="closeBatchNotify()" 
                                        data-dismiss="modal" 
                                        aria-label="Close" 
                                        class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"
                                    >
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i> 
                                        Cancel
                                    </a>
                                </li>
                                <li>
                                    <a 
                                        href="javascript: void(0)" 
                                        @click="sendNotify()" 
                                        class="btn c-solid-btn c-solid-btn--large c-solid-btn--green"
                                    >
                                        <i class="fa fa-paper-plane" aria-hidden="true"></i> 
                                        Send
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import dateTimeConvert from '../../../timeConvert&Compare.js';
    import { VueEditor } from 'vue2-editor';
    import service from '../../../services.js';
    import { global } from '../../../global.js';

    let timeout = null;
    export default {
        components: {
            VueEditor
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
            }),    
        },
        data() {
            return {   
                loading:true,
                afterApi:false,   
                selectedShortType:'fname_asc',
                search_query:'',
                employees:[], 
                savedEmployees:[],
                last_page:null,
                next_page:null,
                getNotificationType:'email',
                selectedEmpId: [],
                attachment : null,
                emailContent: '',
                smsContent: '',
                client_id: '',
                role_id: '',
                hasError: false,
                error: {},
            }
        },
        beforeMount() {
            this.getAllEmployee();
        },
        methods: {
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                let result = '';
                if(phone&&phone.length==10) { 
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
            },

            getNylasSubscriptionStatus(emp) { 
                let status = false;
                if(emp.employable.nylas_subscription&&emp.employable.stripe_subscription) {
                    status = true;
                }
                return status;
            },

            goToMerge(){
                this.$router.push({
                    'path': '/mergeEmployee'
                });
            },

            goToLogin(employeeId) {
                let url="http://login." +global[0].CLIENT_BASE+"#/login/employee/"+btoa(employeeId)+"/"+btoa(this.userToken);
                return url;
            },   
           
            attachmentAdded($event)
            {
              if($event.target.files.length != 0)
                this.attachment = $event.target.files[0];
              else
                 this.attachment = null;
            },

            updateValue(){
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    this.getAllEmployee();
                }, 1000);
            },

            viewSchedule(empId){
                this.$router.push({
                    'path': '/schedule/'+btoa(empId)
                });
            },

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },
            
            sendEmail(emp) {
                console.log(emp);
                let redirect_link = document.location.href.split('#')[0] + '#/resetPassword';
                service.post('auth/forgotPassword', {
                    redirect_link: redirect_link,
                    email: emp.employable.email,
                }, {}).then((res) => {
                    if (res.data.result.status == 0) {
                        this.$notify({
                            title: this.$t('error'),
                            message: res.data.result.message,
                            type: 'error'
                        });
                    } else {
                        this.$notify({
                            title: this.$t('success'),
                            message: this.$t('reset_password_link_sent'),
                            type: 'success'
                        });
                    }

                }).catch((err) => {
                    this.$notify({
                        title: this.$t('error'),
                        message: this.$t('invalid_login_credentials'),
                        type: 'error'
                    });
                });
            },

            sendNotify() {
                var formData;
                this.validateContent('email', this.emailContent);
                this.validateContent('sms', this.smsContent);
                if (this.hasValidationErrors()) {
                    this.$notify({
                        title: this.$t('error'),
                        message: 'Please correct the errors before sending.',
                        type: 'error'
                    });
                    return;
                }
                
                if (this.notifyTab == 'email') {                    
                    formData = new FormData();
                    formData.append('email', this.emailContent);
                    formData.append('client_id', this.client_id);
                    formData.append('employee_ids', JSON.stringify(this.selectedEmpId));
                    if(this.attachment != null || this.attachment == "")
                    {
                      formData.append("attachment", this.attachment);
                    }
                    
                } else {
                    formData = {
                        sms: this.smsContent,
                        client_id:  this.client_id,
                        employee_ids: JSON.stringify(this.selectedEmpId)
                    };
                }
                service.post('employee/notifyEmployee', formData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.client_id,
                        'user-id': this.userID
                    })
                    .then((res) => {
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Notify Successfully.',
                            type: 'success'
                        });
                        this.$modal.hide('batch-notify');
                    }).catch((err) => {
                        console.log(err);

                    });
            },

            sendNylasEvent(emp) {
                if(emp.employable.stripe_subscription&&emp.employable.nylas_subscription) {
                    console.log('Nylas Event');
                    service.post('employee/sendNylasTestEvent', { employee_id: emp.id }, {
                        'Authorization': this.userToken
                    })
                    .then((res) => {
                        console.log(res.data);
                        if(res.data.status_code == "1") {
                            this.$notify({
                                title: 'Success',
                                message:res.data.status_message + ' for ' + res.data.result.email_address,
                                type: 'success'
                            });
                        }else {
                            this.$notify({
                                title: 'Error',
                                message:res.data.status_message,
                                type: 'error'
                            });
                        }
                    }).catch((err) => {
                        console.log(err);
                        this.$notify.error({
                        title: 'Error!',
                        message: 'Something went wrong'
                    });

                    });
                }else if(!emp.employable.stripe_subscription&&!emp.employable.nylas_subscription){
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing Both Nylas and Stripe Subscriptions'
                    });
                }else if(!emp.employable.nylas_subscription) {
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing only Nylas Subscription'
                    });
                }else {
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing only Stripe Subscription'
                    });
                }
            },            

            notifyEmailTab() {
                this.notifyTab = 'email';
            },

            notifySmsTab() {
                this.notifyTab = 'sms';
            },

            addBatchNotify(emp) {
                this.selectedEmpId = [];
                this.getNotificationType=emp.email_notification==1?'email':'sms';
                if(emp.email_notification==1){
                    this.getNotificationType='email';
                    this.notifyTab = 'email';
                }else{
                    this.getNotificationType='sms';
                    this.notifyTab = 'email';
                }
                this.selectedEmpId.push(emp.id);
                this.client_id = emp.client_employee.client_id
                this.role_id = emp.employable.role_id
                this.emailContent = "";
                this.smsContent = "";
                this.$modal.show('batch-notify');
            },

            closeBatchNotify() {
                this.$modal.hide('batch-notify');
            },            

            getAllEmployee() {
                this.$Progress.start();
                this.loading = true;
                this.afterApi = false;
                this.employees=[];
                this.savedEmployees =[];
                service.get('employee/getEmployees', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'status': 'all',
                    'sort': this.selectedShortType,
                    'search': this.search_query,
                }).then((res) => {
                    this.employees = res.data.result.data;
                    this.$Progress.finish();
                    this.last_page = res.data.result.total;
                    this.next_page = res.data.result.next_page_url;
                    this.loading = false;
                    this.afterApi = true;
                    if (this.next_page != null || this.next_page != "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'status': 'all',
                            'sort': this.selectedShortType,
                            'search': this.search_query,
                        }).then((res) => {
                            this.savedEmployees = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    } 
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.afterApi = true;
                });
            },

            async handleScroll() {
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            async loadMore() {
                var arr = this.employees;
                if (this.savedEmployees.length != 0) {
                    this.savedEmployees.forEach(function(entry) {
                        arr.push(entry);
                    })
                    this.savedEmployees=[];
                    if (this.next_page != null || this.next_page != "") {
                        await service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'status': 'all',
                            'sort': this.selectedShortType,
                            'search': this.search_query,
                        }).then((res) => {
                            this.savedEmployees = res.data.result.data;
                            this.page_no += 1;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    }else
                        this.savedEmployees = [];
                } 
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });

            },
            validateContent(fieldName, value) {

                console.log(fieldName, value);
                if (!this.error) {
                    this.$set(this, 'error', {});
                }
                
                this.$set(this.error, fieldName, {
                    hasError: false,
                    message: ''
                });
                
                const plainText = this.getPlainText(value);
                
                // Only validate if there's content
                if (plainText.trim().length > 0) {
                    if (this.containsInvalidContent(plainText)) {
                        this.$set(this.error, fieldName, {
                            hasError: true,
                            message: 'Content contains invalid text. Please review and correct.'
                        });
                    }
                }
            },
    
            getPlainText(html) {
                // Remove HTML tags and get plain text
                const div = document.createElement('div');
                div.innerHTML = html;
                return div.textContent || div.innerText || '';
            },
    
            containsInvalidContent(text) {
                                
                // Example 1: Check for script tags or malicious content
                const scriptPattern = /<script|javascript:|onerror=|onclick=/i;
                
                // Example 2: Check for excessive special characters
                const excessiveSpecialChars = /[.?!,#$^&*()@%|"':;<>]{3,}/;
                
                // Example 3: Check for spam-like patterns (multiple repeated characters)
                const spamPattern = /(.)\1{3,}/;
                
                // Example 4: Check for invalid URLs or suspicious links
                const suspiciousUrl = /bit\.ly|tinyurl|goo\.gl/i;                
                // Return true if any invalid pattern is found
                return scriptPattern.test(text) || 
                excessiveSpecialChars.test(text) || 
                spamPattern.test(text) ||
                suspiciousUrl.test(text);
            },

            hasValidationErrors() {
                // Check if any field has errors
                if (!this.error) return false;
                
                return Object.values(this.error).some(error => error.hasError === true);
            },
        },
        
        created() {            
            this.notifyTab = this.getNotificationType;
        }

    }

</script>
<style scoped>
    .err-msg {
        margin: 2px;
        color: red
    }
    .phone-number-display{
        padding: 5px;
        cursor: pointer;
        color: #222222;
        text-decoration: none !important;
    }
    .employees-list-table-align .calls-table-row .calls-table-cell:nth-child(3) {
        width: 10px!important;
    }
    .send-reset-email {
        color: #006bbd;
        text-decoration: none!important;
    }

    .send-reset-email:hover {
        color: #006bbd!important;
    }

    .nylas-logo {
        height: 25px;
        width: 60px;
        padding: 8px 5px 0;
    }
    .nylas-event {
        font-size: 14px;        
        border-radius: 5px;
        text-decoration: none!important;
        padding: 8px 8px 0;
    }
    .nylas-event.active {       
        background-color: #8158b8!important;        
        border: 1px solid #8158b8;
    }
    .nylas-event.active:hover {       
        color: #8158b8!important;        
        border: 1px solid #8158b8;
    }

    .nylas-event.inactive {       
        background-color: #da4e4e!important;        
        border: 1px solid #da4e4e;
    }

    .nylas-event.inactive:hover {       
        color: #da4e4e!important;        
        border: 1px solid #da4e4e;
    }

    .employees-list-table-align .calls-table-row .calls-table-cell:first-child {
        width: 250px;
        text-align: center;
        padding-left: 10px;
    }
    .employees-list-table-align .calls-table-row .calls-table-cell:nth-child(2) {
        text-align: left;
        width: 201px;
    }
    .pointHere {
        cursor: pointer;
    }

    .tooltip {
        display: block !important;
        z-index: 10000;
    }

    .tooltip .tooltip-inner {
        background: #f9ffb5;
        color: black;
        border-radius: 16px;
        padding: 5px 10px 4px;
    }

    .tooltip .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: #f9ffb5;
    }

    .tooltip[x-placement^="top"] {
        margin-bottom: 5px;
    }

    .tooltip[x-placement^="top"] .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="bottom"] {
        margin-top: 5px;
    }

    .tooltip[x-placement^="bottom"] .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="right"] {
        margin-left: 5px;
    }

    .tooltip[x-placement^="right"] .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip[x-placement^="left"] {
        margin-right: 5px;
    }

    .tooltip[x-placement^="left"] .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
    }

    .tooltip[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
    }

</style>
